var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2150_158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.136 5.6137C24.4875 5.96517 24.4875 6.53502 24.136 6.88649L14.636 16.3865C14.4672 16.5553 14.2383 16.6501 13.9996 16.6501C13.7609 16.6501 13.532 16.5553 13.3632 16.3865L8.99961 12.0229L2.13601 18.8865C1.78453 19.238 1.21469 19.238 0.863213 18.8865C0.511741 18.535 0.511741 17.9652 0.863213 17.6137L8.36321 10.1137C8.53199 9.94492 8.76091 9.8501 8.99961 9.8501C9.2383 9.8501 9.46722 9.94492 9.636 10.1137L13.9996 14.4773L22.8632 5.6137C23.2147 5.26223 23.7845 5.26223 24.136 5.6137Z",
    fill: "#299B9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5996 6.2501C16.5996 5.75304 17.0026 5.3501 17.4996 5.3501H23.4996C23.9967 5.3501 24.3996 5.75304 24.3996 6.2501V12.2501C24.3996 12.7472 23.9967 13.1501 23.4996 13.1501C23.0026 13.1501 22.5996 12.7472 22.5996 12.2501V7.1501H17.4996C17.0026 7.1501 16.5996 6.74715 16.5996 6.2501Z",
    fill: "#299B9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2150_158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trendUp.fd048fb1b1e15912f29699fdfca109f6.svg";
export { ForwardRef as ReactComponent };